export default __webpack_public_path__ + "static/media/PlayerLandingPageFinal.061303ca.mp4";